import { FC } from 'react';

type QuestionCardProps = {
  question: string;
  onClick: (question: string) => Promise<void>;
  disabled?: boolean;
};

export const QuestionCard: FC<QuestionCardProps> = ({ question, onClick, disabled }) => {
  return (
    <button
      onClick={async () => await onClick(question)}
      disabled={disabled}
      className='flex text-center items-center justify-center border rounded-lg py-3 px-4 disabled:pointer-events-none disabled:opacity-50 motion-safe:transition-opacity motion-safe:duration-300 motion-reduce:transition-none'
    >
      <p className='first-letter:capitalize font-bold'>{question}</p>
    </button>
  );
};
